/* eslint-disable react-hooks/exhaustive-deps */
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';
import { useUpdateLead } from '../../../../../../api/leads';
import useToastNotification from '../../../../../../hooks/useToastNotification';
import { useParams } from 'react-router-dom';
import chDateFormatToJsDateFormat from '../../../../../../utils/chDateFormatToJsDateFormat';
import { useEffect } from 'react';

const useComponentForm = () => {
  const { mutate, isSuccess, isLoading, isError } = useUpdateLead();
  const { t } = useTranslation();
  const { leadId } = useParams();
  const defaultValues = {
    zip: '',
    kanton: '',
    address: '',
    birthdate: '',
    married: false,
    estate: false,
  };
  const formSchema = yup.object().shape({
    zip: yup.string().required(t('required_field', { field: t('zip') })),
    address: yup.string().required(t('required_field', { field: t('Address') })),
    birthdate: yup
      .string()
      .max(10, t('invalid_date'))
      .min(10, t('invalid_date'))
      .required(t('required_field', { field: t('birthdate') })),
    married: yup.boolean().required(t('required_field', { field: t('married') })),
    estate: yup.boolean().required(t('required_field', { field: t('estate') })),
  });

  const form = useForm({ defaultValues, resolver: yupResolver(formSchema) });

  const date = useWatch({ control: form.control, name: 'birthdate' });

  useEffect(() => {
    if (date?.length === 10) {
      chDateFormatToJsDateFormat({
        chFormat: date,
        onInvalidDate: () => {
          form.setError('birthdate', { type: 'custom', message: t('invalid_date') });
        },
        onValidDate: () => {
          form.setError('birthdate', undefined);
        },
      });
    }
  }, [date]);

  const onSubmit = (data) => {
    // data.birthdate = chDateFormatToJsDateFormat({ chFormat: data.birthdate });
    mutate({ id: leadId, data: { ...data, birthdate: chDateFormatToJsDateFormat({ chFormat: data.birthdate }) } });
  };

  useToastNotification({
    isShow: isSuccess && !isLoading,
    messageKey: 'thank_you_for_your_submision',
    variant: 'success',
    cb: () => {
      window.location.href = '/thank_you';
    },
  });

  useToastNotification({
    isShow: isError && !isLoading,
    messageKey: 'server_error',
    variant: 'error',
  });

  return {
    ...form,
    onSubmit,
    isLoading,
    isSuccess,
  };
};

export default useComponentForm;
